<template>
  <el-dialog
    :title="(isEdit ? '编辑' : '添加') + '物料信息'"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="400px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="物料分类" prop="ParentType">
            <el-select v-model="form.ParentType" clearable @change="Addrules">
              <el-option value="1" label="总分类"></el-option>
              <el-option value="2" label="明细分类"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="总分类" prop="ParentId">
            <RemoteSelect
              v-model="form.ParentId"
              url="VehicleScrap/GetParentScrap"
              code="ScrapId"
              name="ScrapName"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="物料名称" prop="ScrapName">
            <el-input
              v-model="form.ScrapName"
              placeholder="物料名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="单位" prop="Unit">
            <RemoteSelect
              v-model="form.Unit"
              url="DataDic/GetItemsByType?dicType=CommonUnit"
              code="DicName"
              name="DicName"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="save" :loading="loading"
        >保 存</el-button
      >
      <el-button type="canale" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    
<script>
export default {
  props: ["item"],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      isable: true,
      isEdit: false,
      form: {},
      rules: {
        ParentType: [
          {
            required: true,
            message: "请选择类型",
          },
        ],
        ParentId: [
          {
            required: true,
            message: "请选择总分类",
          },
        ],
        ScrapName: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validLen(50),
        ],
        Unit: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validLen(5),
        ],
      },
    };
  },
  computed: {},
  watch: {
    item: {
      handler: function (v) {
        if (v.ScrapId) {
          this.isEdit = true;
          this.$get("VehicleScrap/GetModel", {
            ScrapId: v.ScrapId,
          }).then((r) => {
            this.init({ ...r.Result });
          });
        } else {
          this.init({});
          this.isEdit = false;
        }
        this.visible = true;
      },
    },
  },
  methods: {
    init(form) {
      this.form = { ...form };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    Addrules(rows) {
      //总分类
      if (rows == 1) {
        //删除单位必填项
         this.$refs.form.clearValidate(["ParentId","Unit"]);
        // 这行必须
        this.rules = { ...this.rules, ParentId: [],Unit:[] };
      } else {
        const Unit={ required: true, message: "不可为空"}
        const ParentId  ={ required: true, message: "请选择总分类"}  
        this.rules={...this.rules,Unit:Unit,ParentId:ParentId}
        console.log(this.rules);
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let params = { ...this.form };
        this.loading = true;
        if (this.isEdit) {
          this.$put("VehicleScrap/Edit", params).then((r) => {
            this.$message.success("修改成功");
            this.visible = false;
            this.$emit("success");
          });
        } else {
          this.$post("VehicleScrap/Add", params).then((r) => {
            this.$message.success("添加成功");
            this.visible = false;
            this.$emit("success");
          });
        }
        this.loading = false;
      });
    },
  },
};
</script>    
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
  margin-top: 10px;
  @include font_color("text-color2");
}
</style>